import gql from "graphql-tag";

export const studyProgrammeElementFragment = gql`
  fragment StudyProgrammeElementFragment on StudyProgrammeElement {
    id
    parent {
      id
    }
    content {
      id
      status
      title
    }
  }
`;

export const examElementFragment = gql`
  fragment ExamElementFragment on ExamSyllabusElement {
    id
    progression {
      allContentIds
      finishedContentIds
    }
    content {
      context {
        id
        title
      }
      id
      status
      title
      ... on Article {
        youtubeVideoId
      }
      ... on Kurssloeyfe {
        title
      }
      ... on Folder {
        type
      }
    }
  }
`;

export const examElementListFragment = gql`
  fragment ExamElementListFragment on ExamSyllabus {
    id
    status
    description {
      content
      isMarkdown
    }
    canUpdateDetails {
      canPerform
    }
    elements {
      ...ExamElementFragment
    }
    examDate
    studyPoints
  }
  ${examElementFragment}
`;

export const studyProgrammeElementListFragment = gql`
  fragment StudyProgrammeElementListFragment on StudyProgramme {
    id
    status
    description {
      content
      isMarkdown
    }
    canUpdateDetails {
      canPerform
    }
    examSyllabusElements: elements(elementType: EXAM_SYLLABUS_ELEMENT) {
      ...StudyProgrammeElementFragment
    }
    folderElements: elements(elementType: FOLDER_ELEMENT) {
      ...StudyProgrammeElementFragment
    }
  }
  ${studyProgrammeElementFragment}
`;

export const folderElementFragment = gql`
  fragment FolderElementFragment on FolderElement {
    id
    finished
    progression {
      finishedContentIds
      allContentIds
    }
    parent {
      id
    }
    content {
      id
      status
      title
      ... on Article {
        youtubeVideoId
      }
      ... on Kurssloeyfe {
        id
      }
      ... on Folder {
        type
      }
    }
  }
`;

export const folderElementListFragment = gql`
  fragment FolderElementListFragment on Folder {
    id
    title
    type
    context {
      title
      id
    }
    description {
      content
      isMarkdown
    }
    canUpdateDetails {
      canPerform
    }
    elements {
      ...FolderElementFragment
    }
  }
  ${folderElementFragment}
`;
